module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "tabs__trigger",
    class: {
      active: _vm.active == _vm.name
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.handleClick(_vm.name), _vm.scrollTo()
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb7d29e4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/TabsTrigger.vue
// module id = SPo7
// module chunks = 1